interface DragRegion {
    left: number;
    top: number;
    height: number;
    width: number;
}

export default function calculateDragRegions(
    nonDraggableHeaderElements: Element[],
    headerHeight: number
): DragRegion[] {
    let prevItemRight = 0;
    const dragRegions = [];

    for (let i = 0; i < nonDraggableHeaderElements.length; i++) {
        const nonDragElement = nonDraggableHeaderElements[i];
        const clientRect = nonDragElement.getBoundingClientRect();

        const newDragRegionWidth = clientRect.left - prevItemRight;
        dragRegions.push({
            left: prevItemRight,
            top: 0,
            height: headerHeight,
            width: newDragRegionWidth
        });

        // assume all elements are centered
        if (clientRect.height < headerHeight) {
            const height = (headerHeight - clientRect.height) / 2;
            dragRegions.push({
                left: clientRect.left,
                top: 0,
                height,
                width: clientRect.width
            });
            dragRegions.push({
                left: clientRect.left,
                top: height + clientRect.height,
                height,
                width: clientRect.width
            });
        }

        prevItemRight = clientRect.right;
    }

    return dragRegions;
}
